package com.milta.feature.ocrscan.data.remote

import com.milta.core.network.apiExceptionOf
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.ocrscan.data.remote.dto.OcrScanResultDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.forms.formData
import io.ktor.client.request.forms.submitFormWithBinaryData
import io.ktor.client.statement.HttpResponse
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess

class OcrScanApi(private val client: HttpClient) {

    /**
     * POST /api/v1/ocr-scans — single synchronous multipart upload, one required field `Photo`
     * (contrat révisé DOM-02, écran B). No session, no `routeId`: the confirmation
     * (`POST /routes/{routeId}/deliveries`) happens separately once the driver has reviewed the rows.
     */
    suspend fun scanPhoto(fileBytes: ByteArray, fileName: String): OcrScanResultDto =
        client.submitFormWithBinaryData(
            url = "$baseUrl/${Endpoints.ocrScans}",
            formData = formData {
                append(
                    key = "Photo",
                    value = fileBytes,
                    headers = Headers.build {
                        append(HttpHeaders.ContentDisposition, "filename=\"$fileName\"")
                    },
                )
            },
        ).decodeOrThrow()

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            // MIL-98 — the AI credit 403 keeps its reset date.
            throw apiExceptionOf(status.value, apiError)
        }
        return body()
    }
}
